import { apiCallAdmin } from "../../services/api-service";

export const getOrgLogoApi = async () => {
  try {
    const response = await apiCallAdmin("GET", "get_org_image");
    return response.data;
  } catch (error) {
    // Error is handled by apiCallAdmin/interceptor
    return { success: false, message: "Failed to fetch org logo" };
  }
};

export const validateTokenApi = async () => {
  try {
    const response = await apiCallAdmin("GET", "validatetoken");
    return response;
  } catch (error) {
    return error.response || { status: 401, data: { success: false } };
  }
};

export const getProfileDetailsApi = async () => {
  try {
    const response = await apiCallAdmin("GET", "basicprofile");
    return response; // always return axios response
  } catch (err) {
    console.error("Error fetching options:", err);
    return err.response || null; // make sure something is returned
  }
};

export const updateProfileImageApi = async (data) => {
  try {
    const response = await apiCallAdmin("POST", "user/image_update", data);
    return response;
  } catch (error) {
    return error.response || { data: { success: false } };
  }
};

export const reportAnIssueApi = async (data) => {
  try {
    const response = await apiCallAdmin("POST", "report_issue", data);
    return response;
  } catch (error) {
    return error.response || { data: { success: false } };
  }
};

export const getReportIssueTypeApi = async () => {
  try {
    const response = await apiCallAdmin("GET", "get_issue_type");
    return response.data;
  } catch (error) {
    return { success: false, data: [] };
  }
};

export const getFAQListApi = async () => {
  try {
    const response = await apiCallAdmin("GET", "help?application=Transport");
    return response.data;
  } catch (error) {
    return { success: false, data: [] };
  }
};

export const getOrgListApi = async () => {
  try {
    const response = await apiCallAdmin("GET", "get_enrolled_orgs");
    return response;
  } catch (error) {
    return error.response || { data: { success: false } };
  }
};

export const getSwitchAccountApi = async (id) => {
  try {
   const isHttpsOnly = process.env.REACT_APP_HTTPS_ONLY === "true";
  return await apiCallAdmin("GET", isHttpsOnly ? `switch_org_http_only/${id}` : `switch_org/${id}`);

  } catch (error) {
    return error.response || { data: { success: false } };
  }
};

export const getRolePermissionApi = async (id) => {
  try {
    const response = await apiCallAdmin("GET", `get_role_permission/${id}`);
    return response;
  } catch (error) {
    return error.response || { data: { success: false } };
  }
};

export const getRoleTypeApi = async () => {
  try {
    const response = await apiCallAdmin("GET", "get_role_type");
    return response;
  } catch (error) {
    return error.response || { data: { success: false } };
  }
};
